import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import Logo from '../../../assets/Logo.png';
import MenuItems from './MenuItems';
import { Link as RouterLink } from 'react-router-dom';

import { Typography, Link, Grid, Box, Paper, Divider } from '@mui/material';

const styles = {
  title: {
    mt: '0.5rem',
    fontWeight: 'bold',
  },

  body: {
    mt: '0.3rem',
  },

  link: {
    '&:hover': { color: 'secondary.main' },
    mt: '0.3rem',
  },
};

const Footer = (props) => {
  return (
    <Paper
      elevation={20}
      sx={{
        padding: { xs: '2rem', md: '4rem' },
        mt: '6rem',
        borderRadius: 5,
      }}>
      <Grid container columnSpacing={10} rowSpacing={0}>
        <Grid item xs={12} lg={4}>
          <Box id='footer'>
            <img src={Logo} alt='' style={{ maxWidth: '20%', height: 'auto' }} />
            <Typography variant='h7' component='h4' sx={styles.title}>
              The 100 Club
            </Typography>
            <Typography variant='body1' sx={styles.body}>
              Singapore's leading private mastermind community for founders.
            </Typography>
            <Grid container sx={{ mt: '1.5rem', textAlign: 'center' }}>
              <Box>
                <Link
                  href='https://www.linkedin.com/company/join-the100club/'
                  underline='none'
                  target='_blank'
                  rel='noopener'>
                  <LinkedInIcon fontSize='large' />
                </Link>
                <Link href='https://t.me/JoinThe100Club' underline='none' target='_blank' rel='noopener'>
                  <TelegramIcon fontSize='large' />
                </Link>
              </Box>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Divider variant='middle' sx={{ display: { lg: 'none' }, my: '3rem' }} />
          <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
            Menu
          </Typography>
          {MenuItems.map((item, index) => (
            <Link
              key={index}
              component={RouterLink}
              to={item.url}
              //onClick={window.scrollTo(0, 0)}
              sx={{
                textDecoration: 'none',
              }}>
              <Typography
                sx={{
                  color: 'primary',
                  cursor: 'pointer',
                  mt: '0.5rem',
                }}>
                {item.title}
              </Typography>
            </Link>
          ))}
        </Grid>
        <Grid item xs={12} lg={4}>
          <Divider variant='middle' sx={{ display: { lg: 'none' }, my: '3rem' }} />
          <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
            Contact Us
          </Typography>
          <Typography
            sx={{
              mt: '0.5rem',
            }}>
            hello@the100club.io
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Footer;
